/* Kaikki search suggestions — inventory-aware and accessible; independent of theme.js. */
(function () {
  'use strict';
  if (!('customElements' in window) || window.customElements.get('predictive-search')) return;
  var css = '.home-search-form__container{position:relative}' +
    '#predictive-search[hidden]{display:none!important}' +
    '#predictive-search{position:absolute;z-index:250;left:0;right:0;top:100%;background:#fff;color:#222;border:1px solid #d0d6dd;box-shadow:0 8px 26px rgba(0,0,0,.15);border-radius:6px;max-height:370px;overflow-y:auto;text-align:left}' +
    '#predictive-search .kk-suggest-title{font-size:15px;font-weight:700;padding:11px 14px 7px}' +
    '#predictive-search .kk-suggest-list{list-style:none;margin:0;padding:0}' +
    '#predictive-search .kk-suggest-list li{padding:0;margin:0}' +
    '#predictive-search .kk-suggest-list a{display:flex;align-items:center;gap:10px;padding:8px 13px;text-decoration:none;color:#222;font-size:15px;line-height:1.3}' +
    '#predictive-search .kk-suggest-list a:hover,#predictive-search .kk-suggest-list a:focus{background:#eef6fa;outline:2px solid #0b729d;outline-offset:-2px}' +
    '#predictive-search .kk-suggest-img{width:46px;height:46px;object-fit:contain;flex-shrink:0}' +
    '#predictive-search .kk-suggest-all{display:block;padding:12px 14px;border-top:1px solid #e2e7eb;font-size:14px;font-weight:700;color:#08749a;text-decoration:none}' +
    '#predictive-search .kk-suggest-item{min-width:0}';
  var style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  class KaikkiPredictiveSearch extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input[name="q"]');
      this.output = this.querySelector('#predictive-search');
      if (!this.input || !this.output) return;
      this.output.hidden = true;
      this.output.setAttribute('role', 'listbox');
      this.input.setAttribute('aria-owns', this.output.id);
      this.input.setAttribute('aria-controls', this.output.id);
      this.input.setAttribute('aria-expanded', 'false');
      this.timer = null;
      this.controller = null;
      this.sequence = 0;
      this.input.addEventListener('input', () => {
        clearTimeout(this.timer);
        var term = this.input.value.trim();
        if (term.length < 2) { this.close(); return; }
        this.timer = setTimeout(() => this.search(term), 180);
      });
      this.input.addEventListener('keydown', e => {
        if (e.key === 'Escape') { this.close(); return; }
        if (e.key === 'ArrowDown' && !this.output.hidden) {
          var link = this.output.querySelector('a');
          if (link) { e.preventDefault(); link.focus(); }
        }
      });
      this.output.addEventListener('keydown', e => {
        if (e.key === 'Escape') { this.close(); this.input.focus(); }
      });
      document.addEventListener('click', e => {
        if (!this.contains(e.target)) this.close();
      });
    }
    close() {
      this.output.hidden = true;
      this.input.setAttribute('aria-expanded', 'false');
    }
    search(term) {
      if (this.controller) this.controller.abort();
      this.controller = new AbortController();
      var run = ++this.sequence;
      var url = '/search/suggest.json?q=' + encodeURIComponent(term) +
        '&resources%5Btype%5D=product&resources%5Blimit%5D=8' +
        '&resources%5Boptions%5D%5Bunavailable_products%5D=hide';
      fetch(url, { signal: this.controller.signal, credentials: 'same-origin' })
        .then(r => { if (!r.ok) throw Error('search'); return r.json(); })
        .then(body => {
          if (run !== this.sequence || this.input.value.trim() !== term) return;
          var items = ((body.resources || {}).results || {}).products || [];
          this.show(items.filter(p => p.available), term);
        })
        .catch(e => { if (e.name !== 'AbortError') this.close(); });
    }
    show(items, term) {
      this.output.replaceChildren();
      if (!items.length) {
        var notice = document.createElement('div');
        notice.className = 'kk-suggest-title';
        notice.textContent = 'No in-stock matches';
        this.output.appendChild(notice);
        var link = document.createElement('a');
        link.href = '/search?q=' + encodeURIComponent(term) + '&type=product';
        link.className = 'kk-suggest-all';
        link.textContent = 'See the full catalog, including sold-out items';
        this.output.appendChild(link);
        this.output.hidden = false;
        this.input.setAttribute('aria-expanded', 'true');
        return;
      }
      var heading = document.createElement('div');
      heading.className = 'kk-suggest-title';
      heading.textContent = 'Available products';
      this.output.appendChild(heading);
      var list = document.createElement('ul');
      list.className = 'kk-suggest-list';
      items.slice(0, 8).forEach(p => {
        var li = document.createElement('li');
        li.setAttribute('role', 'option');
        var a = document.createElement('a');
        a.href = p.url && p.url.startsWith('/') ? p.url : '/products/' + encodeURIComponent(p.handle);
        if (p.image) {
          var img = document.createElement('img');
          img.src = p.image;
          img.className = 'kk-suggest-img';
          img.width = 46; img.height = 46; img.alt = '';
          img.loading = 'lazy';
          a.appendChild(img);
        }
        var title = document.createElement('span');
        title.className = 'kk-suggest-item';
        title.textContent = p.title;
        a.appendChild(title);
        li.appendChild(a);
        list.appendChild(li);
      });
      this.output.appendChild(list);
      var all = document.createElement('a');
      all.href = '/search?q=' + encodeURIComponent(term) + '&type=product';
      all.className = 'kk-suggest-all';
      all.textContent = 'See all search results';
      this.output.appendChild(all);
      this.output.hidden = false;
      this.input.setAttribute('aria-expanded', 'true');
    }
  }
  window.customElements.define('predictive-search', KaikkiPredictiveSearch);
})();